import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import CampaignDashboard from '../CampaignDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import CampaignPageImpl from './CampaignPageImpl';

export default function CampaignPage() {
    const dispatch = useDispatch();
    const { campaignList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < CampaignPageImpl />
    )

}